import React, { useState, useEffect } from "react";
// import { t } from "i18next";
import { useHistory, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { PageHeaderV2 } from "components/PageHeader";
// import PageHeader from "components/PageHeader";
// import ItemsPaymentTotalDetail from "components/OrderHistoryPaymentDetail";
// import OrderGeneralDetail from "components/order-detail/OrderGeneralDetails";
// import ProductsDetail from "components/order-detail/ProductsDetail";
import { Spinner } from "components";
import { useCustomHistory } from "hooks";
import * as ROUTE_CONSTANTS from "routes/constants";
import { OrderSummary } from "modules/dine-in/singleORderDetail/OrderDetails";

//TODO: requires cleanup
function OrderDetail(props) {
  const params = useParams();
  const history = useHistory();
  const [order, setOrder] = useState({});
  const { isLoading } = useSelector((state) => state?.loader);
  const router = useCustomHistory();
  const { DomainType } = useSelector((state) => state.AppReducer);

  let url = ROUTE_CONSTANTS.OUTLET_MY_ORDERS[1];
  const goBack = () => {
    router(url, `/${params?.domainName}${url}`, DomainType);
  };
  useEffect(() => {
    if (history?.location?.state?.order) {
      const { order } = history?.location?.state;
      setOrder(order);
    } else {
      history.push(`/${params?.domainName}${url}`);
    }
  }, []);

  if (isLoading) return <Spinner />;

  return (
      <div>
        <PageHeaderV2
          containerStyleProps={{
            style: {
              zIndex: 100,
            },
          }}
          headerStyleProps={{
            className: "p-6",
          }}
          pageTitle={"Order Details"}
          onGoBack={goBack}
          hideAuth={true}
        />
        <br />
        <br />
        <br />
        <OrderSummary order={order} />
      </div>
  );
}

export default OrderDetail;
